module.exports = __webpack_public_path__ + "static/media/direction-alt.7ebacc12.svg";